// set click event on the menu items, close the menu if the menu of the given item is already open
$('.search-btn').on('click', function(e){
	var element = $(this);

	if(element.hasClass('active') && $(e.target).hasClass('close-search-bar')){
		removeBackgroundBlockHeight();
		menuClose(element);

	}else if(element.hasClass('active') && $(e.target).hasClass('fa-search')) {
		$('form#search').submit();

	}else {
		removeBackgroundBlockHeight();
		menuOpen(element);
	}
});